import React, { Component } from 'react';
import { List } from 'immutable';
import img1 from '../../assets/images/montant_icone.png';
import img2 from '../../assets/images/duree_icone.png';
import img3 from '../../assets/images/icone-differe.png';
import Popin from '../../containers/Popin';
import { format } from '../../utile/utile';
import {formatDureCreditAns,formatDureCreditMois} from '../../utile/utile'
import isEqual from 'lodash/isEqual';
import mensualite_icone from '../../assets/images/mensualite_icone.png';
import show_icn from '../../assets/images/show_icn@2x.png';
import taux_icone from '../../assets/images/taux_icone.png';
import dtc_icone from '../../assets/images/dtc_icone.png';
import ie_icone from '../../assets/images/ie_icone.png';
import somme_icone from '../../assets/images/somme_icone.png';
import message_icone from '../../assets/images/message.png';
import impression_icone from '../../assets/images/impression_icone.png';
import doc_unchecked_icn from '../../assets/images/doc_unchecked_icn@2x.png';
import doc_checked_icn from '../../assets/images/doc_checked_icn@2x.png';

class EspPersoSteps extends Component {
  constructor(props) {
    super(props);
    this.shoHidePop = this.shoHidePop.bind(this);
    this.shoHidePopDetail = this.shoHidePopDetail.bind(this);
    this.shoHidePopRejet = this.shoHidePopRejet.bind(this);
    this.state={
      dureCreditAns : null,
      dureCreditMois : null,
      showVisualiser : false
      }

    this.HideActionPropComm = false ;
  }


  componentWillMount() {
    this.props.showHide('demandeCredit.propositionD');
    if (this.props.maDemande.get('duree_souhaitee') !== undefined) {
      this.initDureeCreditSouhaite()
    }
    if (this.props.maProposition.get('duree_accordee') !== undefined) {
      this.initDureeCreditAccorde()
    }

    if(this.props.maProposition.get('reponseclient') ==='proposition refusee'){
      this.HideActionPropComm=true;
    }

    this.setState({showVisualiser: false});
    this.initDureeCredit();
  }

  initDureeCredit(){
    this.setState({
      dureCreditAns : formatDureCreditAns(this.props.maProposition.get('duree_accordee')),
      dureCreditMois : formatDureCreditMois(this.props.maProposition.get('duree_accordee'))
  })
  }
  initDureeCreditSouhaite(){

    this.setState({
      dureCreditAnsSouhaite : this.props.maDemande.get('canal')==="WEB"
                                                          ?  this.props.maDemande.get('duree_souhaitee')
                                                          : formatDureCreditAns(this.props.maDemande.get('duree_souhaitee')),
      dureCreditMoisSouhaite :this.props.maDemande.get('canal')==="WEB"
                                                          ? 0
                                                          : formatDureCreditMois(this.props.maDemande.get('duree_souhaitee'))
  })
  }
  initDureeCreditAccorde(){
    this.setState({
      dureCreditAnsAccorde : formatDureCreditAns(this.props.maProposition.get('duree_accordee')),
      dureCreditMoisAccorde : formatDureCreditMois(this.props.maProposition.get('duree_accordee'))
  })
  }
  componentWillUpdate(nextProps){
    if ((this.props.maProposition.get('duree_accordee') !== 'NaN' ) && (!isEqual(this.props, nextProps))) {
      this.initDureeCredit();
      this.initDureeCreditSouhaite();
      this.initDureeCreditAccorde();
    }
  }
  shoHidePop() {
    this.props.showHide('demandeCredit.proposition');
  }
  shoHidePopDetail() {
    this.setState({showVisualiser: true});
    this.props.showHide('demandeCredit.propositionD');
    this.forceUpdate();
  }

  shoHidePopRejet(){
    this.props.showHide('demandeCredit.propositionRejetPop');
  }
  renderFirst() {
    return (
      <div
        className="step_container" id="step01"
      >
        <p className="mb20">
              L’étape du traitement de la demande consiste en l’étude des données
               que vous avez renseigné au niveau de formulaire de la demande.
        </p>
        <div className="display_table profil_detail_sim mb20">
          <div className="cell_table demande_infos_zone">
            <p className="main_demande_infos mb20">
              Votre demande N° bcp <strong className="purple_txt">
              {this.props.maDemande.get('init_demande') ? this.props.maDemande.get('init_demande')
              .concat('_', this.props.maDemande.get('clone_number')) : this.props.maDemande.get('referenceId')} </strong> <br />
              Est <strong className="purple_txt">en cours de traitement</strong>
            </p>
            <p className="secondly_demande_infos">
              <span>
              Reçue le : <strong>{this.props.maDemande.get('date_creation')}</strong>
              </span>
            </p>
          </div>
          <div className="cell_table default_size recap_montant">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img1} alt="" width="38px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">Montant du crédit</span><br />
                <span className="detail_sim_num">
               {this.props.maDemande.get('montant_pret')}
                  <span>Dhs</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table default_size recap_duree">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img2} alt="" width="39px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">durée du crédit</span><br />
                <span className="detail_sim_num">
                { this.state.dureCreditAnsSouhaite}
                  <span>Ans </span>
                  {this.state.dureCreditMoisSouhaite > 0 && this.state.dureCreditMoisSouhaite}
                  {this.state.dureCreditMoisSouhaite > 0 &&  <span>Mois</span> }
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table default_size recap_diff">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img3} alt="" width="40px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">différé</span><br />
                <span className="detail_sim_num">
                {this.props.maDemande.get('duree_differe')}
                  <span>Mois</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderSecond() {
    return (
      <div
        className="step_container" id="step02"
      >
      { this.HideActionPropComm===true ?
       <p className="mbText" >
       Vous avez refusé cette proposition de financement.
       </p>:
        <p className="mb20 ">
        Félicitations ! Vous avez reçu une proposition de financement.
          <br />
        Vous pouvez consulter ou imprimer la version détaillée en cliquant sur « Visualiser ».
          <br />
      En acceptant cette proposition de financement, vous entamerez la constitution de votre dossier
        </p>
    }

        <div className="display_table profil_detail_sim">
          <div className="cell_table default_size recap_montant">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img1} alt="" width="38px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">Montant du crédit</span><br />
                <span className="detail_sim_num">
                  {this.props.maProposition.get('montant_accorde')}
                  <span>Dhs</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table default_size recap_duree">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img2} alt="" width="39px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">durée du crédit</span><br />
                <span className="detail_sim_num">
                  {this.state.dureCreditAnsAccorde}
                  <span>Ans </span>
                  {this.state.dureCreditMoisAccorde > 0 && this.state.dureCreditMoisAccorde}
                  {this.state.dureCreditMoisAccorde > 0 &&  <span>Mois</span> }

                </span>
              </div>
            </div>
          </div>
          <div className="cell_table default_size recap_diff">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img3} alt="" width="40px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">différé</span><br />
                <span className="detail_sim_num">
                    {this.props.maProposition.get('differe_accorde')}
                  <span>Mois</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table orange_bg">
            <div className="profile_detail_group">
              <span className="profile_visu_icn">
                <img src={mensualite_icone} alt="" width="39px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels white-txt">mensualité ttc</span><br />
                <span className="detail_sim_num white-txt">
                  {this.props.maProposition.get('echeance')}
                  <span className="white-txt">Dhs</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table show_btn_area">
            <button className="simple_btn" onClick={this.shoHidePopDetail}>
              <img src={show_icn} width="25" alt="" /><br />
              <span>
                visualiser
              </span>
            </button>
          </div>

        </div>
        {this.state.showVisualiser === true &&
            <Popin
              storeKey="demandeCredit.propositionD"
              popin_modals="popin_dialog big_size"
              popinTitle="Proposition commerciale"
              popinTagLine="Détail de la proposition commerciale"
            >
              <div className="body_tpl mb30">
                <div className="p30">
                  <div className="display_table profil_detail_sim">
                    <div className="row_table">
                      <div className="cell_table default_size recap_montant">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABgCAMAAACAJ2RUAAAAkFBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZ06DwKAAAAL3RSTlMABvgNFfKnHDHpmINZSjpnKM23eiLgbshCCe0t27yxh1JOkIvUnl/k2MJyk2OidXezBxAAAARKSURBVFjD7djXcqNAEAXQOwxZIogkgnKygu3+/7/bJWhgAbFKjzovrlJ5mkndTYFhuol34Vsy8CZWSEQB3kFWKefjDb4VKhzxMvdEVyu8ho0kEnYMr7CP1PSN5/E9/SvV8KyxQW0LPCfwqMcYT2C/CvVRMjxMn1BhYskIzhLVZvzxRCypDLmsOUuPPZiI7VlE1LB8ZLdUMWwtfktJeCxH6zUluJpSk4O7iYFG57fHL4hJFUlsdSJm+2jKj8WQGOIAWqR75yaLIdNqaq5EHRHuMxcj5kVirwzqMcIdlvqBBEWNRifqZzL8j0NqYlC/2daxddtxRl4q8mPImohcn/r8ZKi5I4PoJGOInW/1ns+oY+p2Tv2LjkPFUisXGMR3bTe/kGHjlqQqPB5EvR5OoIgkCzeIFLdk475r4Ny8cN/1sbG4eU/nDAPP36BPY9v9OvLwS4YmEakJuuy0zj0by7q2YoCan7SMLr3eqS+53kHnv2VhFvRNetrYJ1FybQxwKZfa6ErqO7EFqyqbfkeNkVbdOesYizp4AbblRcGA4FZnYGEaQzuJZEzw+992tCbxcNbZTJ/hXE0uP6W1kt+6wdMUPI6GIpt2OrTrfxgxstngcWbUMJEh2NcuyxEfr4nE+IKUADfwKTWFdZX6ET3OYcyv1nrSEEk7+Uasefu9RlyRjVQn5xh8WYZL13B3x965WV/UVlcRbZPW619BrqKbnC2ViKFlVUxroAmy9UL8fDwwzSzChTHiMIxkCNpYbc+q++KbccjnndhPJ5F9o0iHhKtEU3N7Nk3Tq2povcUB5HXYaanL1OdANroeUrrV2CEfe7RFbrQd5fbBjqtgRMrGBiAfFtXYRQxbLS5JcOrdJB2lQGq9iy3L5Y1cAMy6lPuyy1c7o10GX6IOsycZJE0Ey4UbKwGgj+ZKuVrEe8NndrcJrnHltx6wbM7f+9WRB4zUsFgtW58DvqcWvRvswnrfndJFGVAbb3Y7h4MBq/ocWgVqUU0iQoXH0b518sp8tJYBcOsc53/d5lJFcxIvXqENJBw1d3X+e5uaux2qZ5uhxL1/TtNFgZVz8GRA52N0JPra2ewnR5Fi5qEcOaKGL6t4/lS0a/eQ/GBApltOZJr7yWTu5Ys+SNTg+b8LqYgbA5A95oxwt0CG1ZcOKocONrdYaOEhoscKyhjaRYbpIZISPCZrRfM0jHcBHCngqYpHuc1o0hnyQslgS0uMaIWHZUpdSl2sDCmGZqRcU5QEj7OobjtqXnnYlByYtMUznLLnZEU38PP7N2H60995tkTGAdjkxbhoojbmT38VYJ7P8c1WRCoAdlLzpcd4GjPpB/6cwb1A03Ai9YVYi6Loc7AdHZBXKA3P21RfYlhIRTQXL2DzvOvoWlFKvACvkYtiqcLNywbHi3QpzwFgmtfwl33nL4ZARCbeYF90N3nF8AY8JBtvY2/w8fHx8fFRoTd6a7A/+j5UHzpbr+EAAAAASUVORK5CYII=" alt="" width="38px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">Montant du crédit</span><br />
                            <span className="detail_sim_num">
                             {this.props.maProposition.get('montant_accorde')}
                              <span>Dhs</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table default_size recap_duree">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABYCAMAAABs+zGpAAABLFBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkb///9bQkbe2dpRNjr8+/tYP0OdjpBTOD2aio1VPEB7Z2qtoaN/a27Wz9D08vKFc3Z4Y2dUOj7c19j6+fm6sLKDcHN0X2JjTFBaQUXh3d1fR0unmpygkpSfkJKTgoVqVFfw7u++tLaypqiVhYdyXWDq5+jRysvGvb7DuruwpKZvWV1dREhOMzf39fbt6urm4uLZ09SQf4KHdXjo5OW1qqyrnqCklZiJd3poUVWklpmLenxsVlrJwcId6JVWAAAAJ3RSTlMA7YBB8/340I7IJ+TCWjARvQUBljbdzGRMRyMJ74l7sp0xGGktow9oBVMMAAAEgElEQVRYw+2XZ1fiQBSGKQoI6GLvuuuWeUlCBKkqXYqigICuve7//w87iREnQ2DMObvfeL7k3JQnN1NuZhwMO18DzsD2joNna9HpXJp22GR9ChpT69z5aejY9U3D8rlZL3S8s59Na9rlck07XIbO5VhxGWinvzih41x303h5R2TzT+kvZ3Tb6OP90M1tghJYEehCwNK0+5tjyzBsOfzud+jpX/3s1tyr85NYFOicWPqiHd2Gzm2+PBeCTmhOi5bhFOg2DMHcV2h8neOuL3j05BbeoqBHoJuY+GLksbwd2t6iNg73z1Bo3m8Em5Of0H0e11j3H3UbczZ0WyLdhmfT9XmCE8JZYQvnWDdEp0TVTFQxxSqNGSZBWQrOL68JdYpaSqeyua6kGLFE41Q6r0ZhQWDzx0hdJn9+KxMiFx9Kqhar+fvfhMZnx2mpAMrp7nEiTCjhxPHuqfafWh2ui3aKxCAci9L4UZPpXD0BsaN9YuKqkqbCmSE6pfSb9KnnlWhHNoKDZyo7JxacxzDpm7XUSWVC2b9p6NZHVYrocfWmHQOOyBAiwNKaha5Q0Fol2en10gfaeyW1TQ+X+Z4KxPfJUPbjeuHndcqT9m1NCQVFa8KWqsSur6/jWp9WqX84B1V4Vgd1+YdyuXwTpW14S29qq6BDTtVsu0TALjwLvA4FiUIfl14I5UGChqLbxD6nn9cZKNBHVizzNhLRIAawhOhU4Z211BWkO0JpKoU3d1z+jE6Ow2epk/Rvu3yNGnGRCHUaYUzOWOika0I5O80YcYT0CVvyMf6CgzopdaENvphkxDHCcH/MRvyZNFZ4nRRLEkqjB42MghPCkH7kda8N0ucEQU6n5uqEcpcpaH3STZuTI485ziZ3y+zbMGOuKHm9HN31pIw2gPMVbqaWu0mzLoEWEx3BZ6ootaJ+Tzyb0shnnrBvLkg4NOsqJda/jwCrU1uEJdUD/3G5mMyGyaeq+TL8jC7TJCzZ6MD0apvTi3SL3FRbZnUJc3YKfZjjpsTcc4gyMXGIebbtGnssnQISvK7eKZ28l6UIsjLfMyFGh4zEogBnhOe2hrg+Ef7kQMeomTMsGjprLsgA9TgqesvieqCmJuEcqSODXDTedffyQFmGx6buNodaU2/2ElJJgU74sfVT7BqSyyxSstXHbmAYfFfIWTx/5JLFkVVXLGIYCcIPrLhcDxskkzVcWQwUF4ZxyCVXQ/HiFAZZ0saNxTCe9S06rZjgJ1kTL2SPeZnc6V7yk2w4fr4EPKNFE+xTk8to8yVgBAGuQMVRT5iatokKV6BG4eO67rVG7sBwfokXrnyOYoYr7pU90oowtOTICVfcRzIF9vawJdyvZxQrpvRgCfdjFKQXEenY37aImUmEbSwqhPi0JY8QY8kjZtaLBhFjLMjE+DfsLBfFLHjsLGbFrHpQlW0stUW4nYiHRRsBG/i9wMOIbYp3zWGLdR8QPxFsouzwbUmwxbPLypSxAS1qpiK/AbXPjC8g2B7bZe37fNALijc4/33NMWbMmDH/FfxD/rnuLwM5Q8g/ZKVkAAAAAElFTkSuQmCC" alt="" width="39px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">durée du crédit</span><br />
                            <span className="detail_sim_num">
                               {this.state.dureCreditAns}
                                <span>Ans </span>
                              {this.state.dureCreditMois > 0 && this.state.dureCreditMois}
                              {this.state.dureCreditMois > 0 &&  <span>Mois</span> }
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table recap_taux size180">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src={taux_icone} alt="" width="38px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">taux
                              <span>(ht)</span>
                            </span><br />
                            <span className="detail_sim_num">
                             {this.props.maProposition.get('taux_accorde')}
                              <span>%</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table recap_diff size180">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABUCAMAAAAiXkCJAAAAQlBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkbN5D2IAAAAFXRSTlMAgPD5qcIVbyvyCaCIENixk+nn05TCOeMUAAAA80lEQVRYw+3WO27DQAxFUQ0pMZmPPnby9r/VAFKUYuyoIJ4LA7yVwOI0IogZLrOU7MnEXwLS5WRvVCOD0EQGkRsZhGxkEFLJIPLqBj+7DhB5Kj5QHsKRfs0e8Ko7G9TZA+pDf575fspH14ijm1HXRpeZuoc6FeZi72vNBKVyj4Ns3PMljXtgWxpY4FmALwfrVLjgqMvMBYG7kUGokUFoIoPIjQxCNh9o0qf4FasLTPi3vJJBCBmUzQPa1LfgKDfuX9bEXRs17h7ebGCC+73hgfu7ggnmlXtgv+v5ZXo++bqJu1KeTKIoiqIoiqIoevNA7AXgD70aNDdliJZPAAAAAElFTkSuQmCC" alt="" width="40px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">différé</span><br />
                            <span className="detail_sim_num">
                              {this.props.maProposition.get('differe_accorde')}
                              <span>Mois</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row_table">
                      <div className="cell_table half_size">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={dtc_icone} alt="" width="38" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">
                              Assurance décès toutes causes
                            </span>
                            <br />
                            <span className="detail_sim_num">
                            {this.props.maProposition.get('frais_assur_dtc')}
                              <span>
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table half_size">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={ie_icone} alt="" width="39px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">
                            assurance incendie explosion
                            </span>
                            <br />
                            <span className="detail_sim_num">
                            {this.props.maProposition.get('frais_assur_ie')}
                              <span>
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row_table">
                      <div className="cell_table default_size ligh_grey_bg">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={somme_icone} alt="" width="38" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <div className="detail_sim_labels">
                            coût total du crédit
                            </div>
                            <div className="cout_total_cridet_details">
                              <span className="cout_txt">
                              {this.props.maProposition.get('interets')}
                                <span>
                                  Dhs<br />(Interêts)
                                </span>
                              </span>
                              <span className="cout_txt mLeft">
                                    {format(this.props.maProposition.get('frais_assur_dtc')
                                    + this.props.maProposition.get('frais_assur_ie'))
                                  }
                                <span>
                                  Dhs<br />(Assurances)
                                </span>
                              </span>
                              <span className="cout_txt mLeft">
                                  {this.props.maProposition.get('frais_dossier')}
                                <span>
                                  Dhs<br />(Frais de dossier)
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table orange_bg size360">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={mensualite_icone} alt="" width="39" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels white-txt">
                            mensualité ttc
                            </span>
                            <br />
                            <span className="detail_sim_num white-txt">
                            {this.props.maProposition.get('echeance')}
                              <span className="white-txt">
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Popin>
        }
        {this.HideActionPropComm ===true  ?
        null :
        <div className="btns_action_zone clearfix align_center">
          <button
            data-text="refuser la proposition"
            className="flat_btn white_btn"
            onClick={this.shoHidePopRejet}
          >
            <span className="demande_pret_btn">refuser la proposition</span>
          </button>
          <button
            data-text="ACCEPTER LA PROPOSITION"
            className={this.props.buttonAccProp ?
             'flat_btn purple_btn ' : 'flat_btn purple_btnflat_btn purple_btn'}
            onClick={this.shoHidePop}
          >
            <span className="demande_pret_btn">ACCEPTER LA PROPOSITION</span>
          </button>
        </div>}
      </div>
    );
  }
  renderThird() {
    return (
      <div
        className="step_container"
        id="step03"
      >
        <p className="mb20">
          Vous avez accepté la proposition de financement suivante :

          <br />

        </p>
        <div className="display_table profil_detail_sim">
          <div className="cell_table default_size recap_montant">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img1} alt="" width="38px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">Montant du crédit</span><br />
                <span className="detail_sim_num">
                  {this.props.maProposition.get('montant_accorde')}
                  <span>Dhs</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table default_size recap_duree">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img2} alt="" width="39px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                 <span className="detail_sim_labels">durée du crédit</span><br />
                    <span className="detail_sim_num">
                               {this.state.dureCreditAns}
                                <span>Ans </span>
                              {this.state.dureCreditMois > 0 && this.state.dureCreditMois}
                              {this.state.dureCreditMois > 0 &&  <span>Mois</span> }
                  </span>
              </div>
            </div>
          </div>
          <div className="cell_table default_size recap_diff">
            <div className="profile_detail_group">
              <span className="profile_visu_icn sim_icone">
                <img src={img3} alt="" width="40px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels">différé</span><br />
                <span className="detail_sim_num">
                    {this.props.maProposition.get('differe_accorde')}
                  <span>Mois</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table orange_bg">
            <div className="profile_detail_group">
              <span className="profile_visu_icn">
                <img src={mensualite_icone} alt="" width="39px" />
              </span>
              <div className="profile_detail detail_sim_lable_container">
                <span className="detail_sim_labels white-txt">mensualité ttc</span><br />
                <span className="detail_sim_num white-txt">
                  {this.props.maProposition.get('echeance')}
                  <span className="white-txt">Dhs</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cell_table show_btn_area">
            <button className="simple_btn" onClick={this.shoHidePopDetail}>
              <img src={show_icn} width="25" alt="" /><br />
              <span>
                visualiser
              </span>
            </button>
        { this.state.showVisualiser  &&
            <Popin
              storeKey="demandeCredit.propositionD"
              popin_modals="popin_dialog big_size"
              popinTitle="Proposition commerciale"
              popinTagLine="Détail de la proposition commerciale"
            >
              <div className="body_tpl mb30">
                <div className="p30">
                  <div className="display_table profil_detail_sim">
                    <div className="row_table">
                      <div className="cell_table default_size recap_montant">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABgCAMAAACAJ2RUAAAAkFBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZ06DwKAAAAL3RSTlMABvgNFfKnHDHpmINZSjpnKM23eiLgbshCCe0t27yxh1JOkIvUnl/k2MJyk2OidXezBxAAAARKSURBVFjD7djXcqNAEAXQOwxZIogkgnKygu3+/7/bJWhgAbFKjzovrlJ5mkndTYFhuol34Vsy8CZWSEQB3kFWKefjDb4VKhzxMvdEVyu8ho0kEnYMr7CP1PSN5/E9/SvV8KyxQW0LPCfwqMcYT2C/CvVRMjxMn1BhYskIzhLVZvzxRCypDLmsOUuPPZiI7VlE1LB8ZLdUMWwtfktJeCxH6zUluJpSk4O7iYFG57fHL4hJFUlsdSJm+2jKj8WQGOIAWqR75yaLIdNqaq5EHRHuMxcj5kVirwzqMcIdlvqBBEWNRifqZzL8j0NqYlC/2daxddtxRl4q8mPImohcn/r8ZKi5I4PoJGOInW/1ns+oY+p2Tv2LjkPFUisXGMR3bTe/kGHjlqQqPB5EvR5OoIgkCzeIFLdk475r4Ny8cN/1sbG4eU/nDAPP36BPY9v9OvLwS4YmEakJuuy0zj0by7q2YoCan7SMLr3eqS+53kHnv2VhFvRNetrYJ1FybQxwKZfa6ErqO7EFqyqbfkeNkVbdOesYizp4AbblRcGA4FZnYGEaQzuJZEzw+992tCbxcNbZTJ/hXE0uP6W1kt+6wdMUPI6GIpt2OrTrfxgxstngcWbUMJEh2NcuyxEfr4nE+IKUADfwKTWFdZX6ET3OYcyv1nrSEEk7+Uasefu9RlyRjVQn5xh8WYZL13B3x965WV/UVlcRbZPW619BrqKbnC2ViKFlVUxroAmy9UL8fDwwzSzChTHiMIxkCNpYbc+q++KbccjnndhPJ5F9o0iHhKtEU3N7Nk3Tq2povcUB5HXYaanL1OdANroeUrrV2CEfe7RFbrQd5fbBjqtgRMrGBiAfFtXYRQxbLS5JcOrdJB2lQGq9iy3L5Y1cAMy6lPuyy1c7o10GX6IOsycZJE0Ey4UbKwGgj+ZKuVrEe8NndrcJrnHltx6wbM7f+9WRB4zUsFgtW58DvqcWvRvswnrfndJFGVAbb3Y7h4MBq/ocWgVqUU0iQoXH0b518sp8tJYBcOsc53/d5lJFcxIvXqENJBw1d3X+e5uaux2qZ5uhxL1/TtNFgZVz8GRA52N0JPra2ewnR5Fi5qEcOaKGL6t4/lS0a/eQ/GBApltOZJr7yWTu5Ys+SNTg+b8LqYgbA5A95oxwt0CG1ZcOKocONrdYaOEhoscKyhjaRYbpIZISPCZrRfM0jHcBHCngqYpHuc1o0hnyQslgS0uMaIWHZUpdSl2sDCmGZqRcU5QEj7OobjtqXnnYlByYtMUznLLnZEU38PP7N2H60995tkTGAdjkxbhoojbmT38VYJ7P8c1WRCoAdlLzpcd4GjPpB/6cwb1A03Ai9YVYi6Loc7AdHZBXKA3P21RfYlhIRTQXL2DzvOvoWlFKvACvkYtiqcLNywbHi3QpzwFgmtfwl33nL4ZARCbeYF90N3nF8AY8JBtvY2/w8fHx8fFRoTd6a7A/+j5UHzpbr+EAAAAASUVORK5CYII=" alt="" width="38px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">Montant du crédit</span><br />
                            <span className="detail_sim_num">
                             {this.props.maProposition.get('montant_accorde')}
                              <span>Dhs</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table default_size recap_duree">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,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" alt="" width="39px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">durée du crédit</span><br />
                            <span className="detail_sim_num">
                               {this.state.dureCreditAns}
                                <span>Ans </span>
                              {this.state.dureCreditMois > 0 && this.state.dureCreditMois}
                              {this.state.dureCreditMois > 0 &&  <span>Mois</span> }
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table recap_taux size180">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src={taux_icone} alt="" width="38px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">taux
                              <span>(ht)</span>
                            </span><br />
                            <span className="detail_sim_num">
                             {this.props.maProposition.get('taux_accorde')}
                              <span>%</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table recap_diff size180">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn sim_icone">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABUCAMAAAAiXkCJAAAAQlBMVEUAAABbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkZbQkbN5D2IAAAAFXRSTlMAgPD5qcIVbyvyCaCIENixk+nn05TCOeMUAAAA80lEQVRYw+3WO27DQAxFUQ0pMZmPPnby9r/VAFKUYuyoIJ4LA7yVwOI0IogZLrOU7MnEXwLS5WRvVCOD0EQGkRsZhGxkEFLJIPLqBj+7DhB5Kj5QHsKRfs0e8Ko7G9TZA+pDf575fspH14ijm1HXRpeZuoc6FeZi72vNBKVyj4Ns3PMljXtgWxpY4FmALwfrVLjgqMvMBYG7kUGokUFoIoPIjQxCNh9o0qf4FasLTPi3vJJBCBmUzQPa1LfgKDfuX9bEXRs17h7ebGCC+73hgfu7ggnmlXtgv+v5ZXo++bqJu1KeTKIoiqIoiqIoevNA7AXgD70aNDdliJZPAAAAAElFTkSuQmCC" alt="" width="40px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">différé</span><br />
                            <span className="detail_sim_num">
                              {this.props.maProposition.get('differe_accorde')}
                              <span>Mois</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row_table">
                      <div className="cell_table half_size">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={dtc_icone} alt="" width="38" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">
                              Assurance décès toutes causes
                            </span>
                            <br />
                            <span className="detail_sim_num">
                            {this.props.maProposition.get('frais_assur_dtc')}
                              <span>
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table half_size">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={ie_icone} alt="" width="39px" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels">
                            assurance incendie explosion
                            </span>
                            <br />
                            <span className="detail_sim_num">
                            {this.props.maProposition.get('frais_assur_ie')}
                              <span>
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row_table">
                      <div className="cell_table default_size ligh_grey_bg">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={somme_icone} alt="" width="38" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <div className="detail_sim_labels">
                            coût total du crédit
                            </div>
                            <div className="cout_total_cridet_details">
                              <span className="cout_txt">
                              {this.props.maProposition.get('interets')}
                                <span>
                                  Dhs<br />(Interêts)
                                </span>
                              </span>
                              <span className="cout_txt mLeft">
                                    {format(this.props.maProposition.get('frais_assur_dtc')
                                    + this.props.maProposition.get('frais_assur_ie'))
                                  }
                                <span>
                                  Dhs<br />(Assurances)
                                </span>
                              </span>
                              <span className="cout_txt mLeft">
                                  {this.props.maProposition.get('frais_dossier')}
                                <span>
                                  Dhs<br />(Frais de dossier)
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cell_table orange_bg size360">
                        <div className="profile_detail_group">
                          <span className="profile_visu_icn">
                            <img src={mensualite_icone} alt="" width="39" />
                          </span>
                          <div className="profile_detail detail_sim_lable_container">
                            <span className="detail_sim_labels white-txt">
                            mensualité ttc
                            </span>
                            <br />
                            <span className="detail_sim_num white-txt">
                            {this.props.maProposition.get('echeance')}
                              <span className="white-txt">
                                Dhs
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Popin>
        }
          </div>
        </div>
        <br/>
         {this.props.maDemande.get('declaratifPj') !==undefined && this.props.maDemande.get('declaratifPj')==='Basee sur declaratif' ?
         <p>
          Vous pouvez dès à présent commencer la constitution de votre dossier.
          <br />
          Ci-dessous la liste des pièces justificative à déposer auprès de votre agence :
          <br/>
        </p>:
        null
      }

        <br/>
        <div className="docs_list_container">
        {this.props.mesDocs
        .map((doc, index) => (
          <div key={index}
            className={`doc_check_container ${doc.get('received') === 'non' ? ' unchecked' : ''}`}
          >
            <div className="doc_lbl">
              <p>
                {doc.get('libelle_doc')}
              </p>
            </div>
            <div className="doc_status">
              <img src={doc_unchecked_icn} className="unchecked_icn" alt="" width="26" />
              <img src={doc_checked_icn} className="checked_icn" alt="" width="26" />
            </div>
            <div className="doc_comments">
              <button type="button">
                0
              </button>
            </div>
          </div>
        ))}
        </div>
        <div className="align_right">
          <button className="action_btn_icn">
            <img src={message_icone} alt="Message" width="23" />
          </button>
          <button className="action_btn_icn print_btn">
            <img src={impression_icone} alt="Impression" width="20" />
          </button>
        </div>
      </div>
    );
  }
  renderFourth() {
    return (
      <div
        className="step_container" id="step04"
      >
        <p className="mb20">
        Nous avons reçu l’ensemble de vos pièces justificatives.
         Nous allons dès à présent étudier votre dossier afin d’accéder aux étapes suivantes
        </p>
        <div>
          <div className="doc_check_container full_size mb10">
            <div className="doc_lbl">
              <div>
                <h2>
                    Contrat disponible en agence
                </h2>
                <p>
                    Nous vous invitons à vous rendre à votre agence
                     pour récupérer et signer votre Offre de Crédit/Contrat
                </p>
              </div>
            </div>
            <div className="doc_status">
              <img src={doc_unchecked_icn} className="unchecked_icn" alt="" width="26" />
              <img src={doc_checked_icn} className="checked_icn" alt="" width="26" />
            </div>
          </div>
          <div className="doc_check_container unchecked full_size mb10">
            <div className="doc_lbl">
              <p>
                    DÉLIVRANCE DU CONTRAT EN AGENCE
              </p>
            </div>
            <div className="doc_status">
              <img src={doc_unchecked_icn} className="unchecked_icn" alt="" width="26" />
              <img src={doc_checked_icn} className="checked_icn" alt="" width="26" />
            </div>
          </div>

          <div className="doc_check_container unchecked full_size mb10">
            <div className="doc_lbl">
              <p>
                  RÉCUPÉRATION DU CONTRAT SIGNÉ PAR L&apos;AGENCE
              </p>
            </div>
            <div className="doc_status">
              <img src={doc_unchecked_icn} className="unchecked_icn" alt="" width="26" />
              <img src={doc_checked_icn} className="checked_icn" alt="" width="26" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderFifth() {
    return (
      <div
        className="step_container" id="step05"
      >
        <h3 className="orange_txt results_title">
          Félicitation !
        </h3>
        <p className="mb20">
          Votre chèque est disponible  en agence
        </p>
        <p>
        Vous pouvez dès à présent finaliser l’acquisition de votre bien.
        Nous vous invitons à vous rendre dès que possible à
         votre agence pour récupérer votre chèque.
        </p>
      </div>
    );
  }
  render() {
    return (
      <div>
      {(() => {
        switch (this.props.statutEncours) {
          case 'Nouvelle Demande':
            return this.renderFirst();
          case 'Etude':
            return this.renderFirst();
          case 'etude middle office':
            return this.renderFirst();
          case 'decision':
            return this.renderFirst();
          case 'en cours':
              return this.renderFirst();
          case 'reception':
            return this.renderSecond();
          case 'Reponse Client':
            return this.renderSecond();
          case 'communication liste':
            return this.renderThird();
          case 'constitution':
            return this.renderThird();
          case 'contrat':
            return this.renderFourth();
          case 'concretisation':
            return this.renderFifth();
          default:
            return null;
        }
      })()}
      </div>
    );
  }
}

EspPersoSteps.propTypes = {
  statutEncours: React.PropTypes.string,
  showHide: React.PropTypes.func,
  maProposition: React.PropTypes.instanceOf(Map),
  maDemande: React.PropTypes.instanceOf(Map).isRequired,
  buttonAccProp: React.PropTypes.bool,
  mesDocs: React.PropTypes.instanceOf(List),
};

export default EspPersoSteps;
